/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DossierAdmissionFichierGridDto
 */
export interface DossierAdmissionFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierGridDto
     */
    iddossierAdmissionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierAdmissionFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierAdmissionFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DossierAdmissionFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DossierAdmissionFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the DossierAdmissionFichierGridDto interface.
 */
export function instanceOfDossierAdmissionFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DossierAdmissionFichierGridDtoFromJSON(json: any): DossierAdmissionFichierGridDto {
    return DossierAdmissionFichierGridDtoFromJSONTyped(json, false);
}

export function DossierAdmissionFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DossierAdmissionFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddossierAdmissionFichier': !exists(json, 'iddossierAdmissionFichier') ? undefined : json['iddossierAdmissionFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function DossierAdmissionFichierGridDtoToJSON(value?: DossierAdmissionFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddossierAdmissionFichier': value.iddossierAdmissionFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

